import { TrailerEntity } from "@ots-frontend/ots-data";
import { BaseEntitySelect, BaseEntitySelectProps } from "../base-entity-select";

export type BaseTrailerSelectProps = BaseEntitySelectProps<TrailerEntity>;

export const BaseTrailerSelect = (props: BaseTrailerSelectProps) => {
  return <BaseEntitySelect {...props} />;
};
